import useAuth from "./useAuth";

export const useAuthorization = () => {
  let { user } = useAuth();
  // console.log(user  )
  let auth = {
    isPermission: (permission) => {
      let check = user?.menu?.some((me) => {
        return me?.url == permission;
      });
      return check;
    },
    isPermissionGroup: (routeGroup) => {
      let check = routeGroup?.some((router) => {
        return user?.menu?.some((me) => me?.url == router?.key);
      });
      return check;
    },
    isLogged: user?.id,
  };
  return auth;
};
